const SUBJECT_ONLY_EXCLUDED_FIELDS = new Set([
  'editableData.improvements.gla',
  'editableData.improvements.bedrooms',
  'editableData.improvements.fullBaths',
  'editableData.improvements.halfBaths',
  'editableData.improvements.basement.bedrooms',
  'editableData.improvements.basement.fullBaths',
  'editableData.improvements.basement.halfBaths',
  'editableData.improvements.adu.fullBaths',
  'editableData.improvements.adu.halfBaths',
  'editableData.site.area',
  'editableData.arv.improvements.gla',
  'editableData.arv.improvements.bedrooms',
  'editableData.arv.improvements.fullBaths',
  'editableData.arv.improvements.halfBaths',
  'editableData.arv.improvements.basement.bedrooms',
  'editableData.arv.improvements.basement.fullBaths',
  'editableData.arv.improvements.basement.halfBaths',
  'editableData.arv.improvements.adu.fullBaths',
  'editableData.arv.improvements.adu.halfBaths',
]);

const TOP_LEVEL_IMPROVEMENT_FIELD_PATTERN = /^editableData\.(?:arv\.)?improvements\.([^.]+)$/;

const TOP_LEVEL_IMPROVEMENT_FIELDS = new Set(['bedrooms', 'fullBaths', 'halfBaths']);

const SUB_FEATURE_FIELD_PATTERN = /^editableData\.(?:arv\.)?improvements\.([^.]+)\.(.+)$/;

const NON_BASEMENT_AREA_PATTERN = /^editableData\.(?:arv\.)?improvements\.([^.]+)\.area$/;

export const isTopLevelImprovementField = (fieldName: string): boolean => {
  const match = TOP_LEVEL_IMPROVEMENT_FIELD_PATTERN.exec(fieldName);
  return match !== null && TOP_LEVEL_IMPROVEMENT_FIELDS.has(match[1] ?? '');
};

export const getSubFeatureParentKey = (fieldName: string): string | undefined => {
  if (isTopLevelImprovementField(fieldName)) return undefined;

  const match = SUB_FEATURE_FIELD_PATTERN.exec(fieldName);
  return match?.[1];
};

export const isInconsistentFeatureField = (fieldName: string, propertyId: string): boolean => {
  if (propertyId === 'subject' && SUBJECT_ONLY_EXCLUDED_FIELDS.has(fieldName)) return false;

  if (isTopLevelImprovementField(fieldName)) return true;

  const match = SUB_FEATURE_FIELD_PATTERN.exec(fieldName);
  if (!match) return false;

  const [, feature] = match;
  if (feature === undefined) return false;

  return feature === 'basement' || !NON_BASEMENT_AREA_PATTERN.test(fieldName);
};
